"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var protocol_base_1 = require("./utilities/protocol-base");
var HttpContentStream = /** @class */ (function () {
    function HttpContentStream(content) {
        this.id = protocol_base_1.generateGuid();
        this.content = content;
        this.description = { id: this.id, type: (this.content.headers) ? this.content.headers.type : 'unknown', length: (this.content.headers) ? this.content.headers.contentLength : 0 };
    }
    return HttpContentStream;
}());
exports.HttpContentStream = HttpContentStream;
var HttpContent = /** @class */ (function () {
    function HttpContent(headers, stream) {
        this.headers = headers;
        this.stream = stream;
    }
    HttpContent.prototype.getStream = function () {
        return this.stream;
    };
    return HttpContent;
}());
exports.HttpContent = HttpContent;
//# sourceMappingURL=httpContentStream.js.map